'use client';

import { addAddress, type UpdateShippingAddressRequest, updateShippingAddress } from '@libs/api-proxy-client';
import { SubscriptionOrder, useUserSession } from '@libs/common-next';
import { PROFILE_DATA } from '@libs/shared-ui';

const convertSubscriptionAddressToPayload = (addressData: UpdateShippingAddressRequest) => {
    return {
        firstName: addressData.firstName,
        lastName: addressData.lastName,
        countryAbbreviation: addressData.country,
        stateProvinceAbbreviation: addressData.state,
        zipPostalCode: addressData.postalCode,
        city: addressData.city,
        streetLine1: addressData.line1,
        streetLine2: addressData.line2,
        isActive: true,
        isPrimary: false,
        phoneNumber: addressData.phone,
        addressType: 'other',
    };
};

export const useAddressManager = () => {
    const { updateProfileData } = useUserSession();

    const createNewAddress = async (subscriptionAddress: UpdateShippingAddressRequest) => {
        const payload = convertSubscriptionAddressToPayload(subscriptionAddress);

        const response = await addAddress(payload);

        if (!response) {
            throw new Error('Address API request failed');
        }

        if (response && updateProfileData) {
            /** Function to update the address data inside the UserSessionWrapper */
            await updateProfileData?.(PROFILE_DATA.ADDRESSES);
            await updateProfileData?.(PROFILE_DATA.PROFILE);
        }
    };

    const linkAddressToOG = async (addressData: UpdateShippingAddressRequest, order: SubscriptionOrder) => {
        const orderId = order.id;
        const orderSubscriptions = order.items.reduce<string[]>((subscriptionIds, item) => {
            if (item.subscription) {
                subscriptionIds.push(item.subscription.id);
            }
            return subscriptionIds;
        }, []);

        await updateShippingAddress([orderId], orderSubscriptions, addressData);
    };

    return {
        createNewAddress,
        linkAddressToOG,
    };
};
